import { Code01 } from "@untitledui/icons";
import { Avatar } from "@/components/base/avatar/avatar";
import { cx } from "@/utils/cx";

export interface FormRulesFeaturedIconProps {
	className?: string;
}

/**
 * Blue circular Code icon used in the form rule editor modal and empty states.
 */
export function FormRulesFeaturedIcon({
	className,
}: FormRulesFeaturedIconProps) {
	return (
		<div className={cx("relative w-max", className)}>
			<Avatar
				size="2xl"
				placeholderIcon={({ className: iconClassName }) => (
					<Code01
						className={iconClassName ?? ""}
						size={32}
						style={{ stroke: "#2563EB" }}
					/>
				)}
				className="border! border-[#BFDBFE]! bg-[#EFF6FF]! outline-none!"
			/>
		</div>
	);
}
